import { useEffect, useState } from "react";

import EmptyState from "../components/EmptyState";
import LoadingState from "../components/LoadingState";
import PageTitle from "../components/PageTitle";
import SummaryCard from "../components/SummaryCard";
import { adminApi, buildQuery } from "../services/adminApi";
import { formatCurrency } from "../utils/formatters";

function AnalyticsList({ items, getKey, children }) {
  if (!items?.length) {
    return <EmptyState />;
  }

  return (
    <div className="admin-list">
      {items.map((item) => (
        <article key={getKey(item)}>{children(item)}</article>
      ))}
    </div>
  );
}

export default function AnalyticsPage({ filters }) {
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    adminApi(`/analytics/${buildQuery(filters)}`)
      .then(setAnalytics)
      .catch(console.error);
  }, [filters]);

  if (!analytics) {
    return (
      <main className="admin-page">
        <LoadingState />
      </main>
    );
  }

  return (
    <main className="admin-page flex flex-column gap-5">
      <PageTitle eyebrow="Analytics" title="Performance Reporting">
        Server-calculated totals exclude cancelled and refunded orders from normal sales.
      </PageTitle>

      <section className="admin-summary">
        <SummaryCard label="Total revenue" value={formatCurrency(analytics.total_revenue)} />
        <SummaryCard label="Order count" value={analytics.order_count} />
        <SummaryCard label="Average order" value={formatCurrency(analytics.average_order_value)} />
        <SummaryCard label="Catering requests" value={analytics.catering_request_count} />
      </section>

      <section className="grid-2">
        <section className="card admin-panel">
          <header className="card-header">
            <h2>Revenue by Location</h2>
          </header>
          <div className="card-body">
            <AnalyticsList
              items={analytics.revenue_by_location}
              getKey={(location) => location.location || location.location__name}
            >
              {(location) => (
                <>
                  <strong>{location.location__name}</strong>
                  <span>{location.order_count} orders</span>
                  <span>{formatCurrency(location.revenue)}</span>
                </>
              )}
            </AnalyticsList>
          </div>
        </section>

        <section className="card admin-panel">
          <header className="card-header">
            <h2>Item Performance</h2>
          </header>
          <div className="card-body">
            <AnalyticsList
              items={analytics.item_performance}
              getKey={(item) => item.item_name}
            >
              {(item) => (
                <>
                  <strong>{item.item_name}</strong>
                  <span>{item.quantity} sold</span>
                  <span>{formatCurrency(item.revenue)}</span>
                </>
              )}
            </AnalyticsList>
          </div>
        </section>
      </section>
    </main>
  );
}